//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCouponType,getUseType,getCouponStatus,getGrantType} from "@/assets/js/dict";
export default {
  created(){
    getCouponType().then(res=>{
      this.couponTypeList=res
    })
    getUseType().then(res=>{
      this.useTypeList= res
    })
    getCouponStatus().then(res=>{
      this.couponStatusList=res
    })
    getGrantType().then(res=>{
      this.grantTypeList= res
    })
  },
  data: () => ({
    couponTypeList:[],
    useTypeList:[],
    couponStatusList:[],
    grantTypeList:[],
    tabt:2,
    useType:0,
    loading: false,
    finished: false,
    list: [],
    form:{
      title:'',
      couponStatus:2,
      useType:'',
      pageIndex:1,
      pageSize:10
    },
    userType:''
  }),
  methods: {
    // 切换状态
    changeTab(index){
      this.tabt = index
      this.form.couponStatus=index
      this.form.pageIndex=1
      this.list=[]
      this.getList()
    },
    // 修改类型
    changeUseType(val){
      this.useType = val
        if(val==0){
          this.form.useType=''
        }else{
          this.form.useType=val
        }
        this.form.pageIndex=1;
        this.list=[]
        this.getList()
    },
    // 优惠券列表
     getList() {
      this.loading = true;
      this.$get("/pay/user/coupon/list", this.form, function (res) {
        var newArr = res.data.records;
        if (!newArr || newArr.length === 0) {
          this.finished = true;
        } else {
          for(var i=0;i<newArr.length;i++){
            newArr[i].show=0
          }
          this.list.push(...newArr);
          this.form.pageIndex = this.form.pageIndex + 1;
        }
        this.loading = false;
      });
    },
    // 展示详细信息
    showMore(index){
      var list = this.list
      if(list[index].show==1){
        list[index].show=0
      }else{
        list[index].show=1
      }
    },

    // 点击立即使用
    useNow(row){
      if(this.tabt!=2){
        return
      }
      var userType = this.userType
      if(row.couponType==1){  //满减券 发包商使用
        if(userType==3){
          this.$message.info('此券只可发包商使用')
        }
        if(userType==2){
          this.$router.push({
            path:'/release/index?releaseType=1'
          })
        }
      }
      if(row.couponType==2){  //红包券 服务商使用
        if(userType==2){
          this.$message.info('此券只可服务商使用')
        }
        if(userType==3){
          this.$router.push({
            path:'/project'
          })
        }
      }
    },

    // 获取用户信息
    getUserInfo(){
      this.$get('/sys/user/info','',function(res){
        this.userType = res.data.currentUserType
      })
    }
  },
  mounted() {
    this.getUserInfo()
  },
};
